import { Expose, Type } from 'class-transformer'
import { Truck } from 'react-feather'

import { Audit } from './Audit'
import { Batch } from './Batch'
import { Container } from './Container'
import { Sku } from './Sku'

export class AuditResultUnitLoc {
  static type = 'auditresultunitloc'
  static typeDisplay = 'Audit Result Units'
  static icon = Truck

  type = AuditResultUnitLoc.type
  typeDisplay = AuditResultUnitLoc
  icon = AuditResultUnitLoc.icon

  @Type(() => Audit)
  audit: Audit = new Audit()

  @Type(() => Container)
  container: Container = new Container()

  @Type(() => Sku)
  sku: Sku = new Sku()

  @Type(() => Batch)
  batch: Batch = new Batch()

  @Expose({ name: 'num_units' })
  numUnits: number = 1
}
